export const ListAnimationMixin = {
  methods: {
    onListAnimationBeforeLeave: function (el): void {
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(el);
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft)}px`;
      el.style.top = `${el.offsetTop - parseFloat(marginTop)}px`;
      el.style.width = width;
      el.style.height = height;
    } // https://forum.vuejs.org/t/transition-group-leave-transition-w-position-absolute-jumping-to-top-left-flip/12258/4
  }
};
